module.exports = __webpack_public_path__ + "static/img/10.7509297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/10.png
// module id = 5QIW
// module chunks = 0